export default __webpack_public_path__ + "static/media/pointers.6fdf8e0d.png";